import { render, staticRenderFns } from "./ServiceStatement.vue?vue&type=template&id=c132cc20&scoped=true"
import script from "./ServiceStatement.vue?vue&type=script&lang=ts"
export * from "./ServiceStatement.vue?vue&type=script&lang=ts"
import style0 from "./ServiceStatement.vue?vue&type=style&index=0&id=c132cc20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c132cc20",
  null
  
)

export default component.exports